exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Imports
var getUrl = require("../../../../node_modules/css-loader/dist/runtime/getUrl.js");
var ___CSS_LOADER_URL___0___ = getUrl(require("../../../../assets/friseFooter.png"));
// Module
exports.push([module.id, ".footer {\n  height: 35px;\n  margin-top: -35px;\n  width: 100%;\n  background: url(" + ___CSS_LOADER_URL___0___ + ") center center/cover repeat; }\n  @media (max-width: 576px) {\n    .footer {\n      height: 28px;\n      margin-top: -28px; } }\n", ""]);
